import { createContext } from "react";
// biome-ignore lint/style/noRestrictedImports: component usage
import type { DraggableProvidedDragHandleProps, DraggableRubric, DraggableStateSnapshot } from "react-beautiful-dnd";

import { useRequiredContext } from "~/tools/use-required-context";

export interface DraggableContextValue extends DraggableStateSnapshot, Omit<DraggableRubric, "mode"> {}

const DraggableContext = createContext<null | {
	dragHandleProps: undefined | DraggableProvidedDragHandleProps;
	value: DraggableContextValue;
}>(null);

export const DraggableContextProvider = DraggableContext.Provider;

export function useDragHandleProps(): undefined | DraggableProvidedDragHandleProps {
	const { dragHandleProps } = useRequiredContext(DraggableContext, {
		providerName: "Draggable",
	});

	return dragHandleProps;
}

export function useDraggableContext(): DraggableContextValue {
	const { value } = useRequiredContext(DraggableContext, {
		providerName: "Draggable",
	});

	return value;
}
